import FaqModal from "./faqModal"

export default FaqModal
